import React from "react";
import './../dtr.scss';
import dtrimage from '../../../assets/dtr.png';
import logo from '../../../assets/msw-logo.png';
import { useQuery } from "@tanstack/react-query";
import axios from "../../../api/axios";
import Error from "../../error/Error";
import { NavLink } from "react-router-dom";

const Department = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');

    const { data: timesheets, isLoading, error } = useQuery({
        queryKey: ['timesheetDepartment'],
        queryFn: async () => {
            const res = await axios.get('dtr/timesheets/department', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        enabled: !!token
    });



    return (
        <div className={`dtr-department ${isLoading && 'loading'}`}>
            {
                error
                    ? (
                        <Error message={error.response?.data.response} />
                    ) : (
                        <div className="content">
                            <div className="header">
                                <div>
                                    <h2>{timesheets?.header?.department}</h2>
                                    <p>{timesheets?.header?.payrolldate}</p>
                                </div>
                            </div>
                            
                            <div className="department">
                                {
                                    isLoading
                                        ? (
                                            [...Array(5)].map((_, i) => (
                                                <div key={i} className="employee">
                                                    <a href="#">
                                                        <div className="title">
                                                            <i className="fa fa-file-excel"></i>
                                                            <span title="Resty Alejo">Resty Alejo</span>
                                                        </div>
                                                        <div className="image">
                                                            <img src={dtrimage} alt="Resty Alejo" />
                                                        </div>
                                                    </a>
                                                </div>
                                            ))
                                        ) : (
                                            timesheets?.employees.map((item) => (
                                                <div key={item.id} className="employee">
                                                    <NavLink to={item.link} target="_blank">
                                                        <div className="title">
                                                            <i className="fa fa-file-excel"></i>
                                                            <span title={item.name}>{item.name}</span>
                                                        </div>
                                                        <div className="image">
                                                            <img src={dtrimage} alt={item.name} />
                                                        </div>
                                                    </NavLink>
                                                </div>
                                            ))
                                        )
                                }
                            </div>

                            <div className="dtr-footer">
                                <div className='logo'>
                                    <img src={logo} alt='Logo' />
                                </div>
                                <p>&copy; Megasportsworld 2024.</p>
                            </div>
                        </div>
                    )
            }
        </div>
    )
}

export default Department;